import type { ReactNode } from 'react';
import { ProgressSteps, TopBar, UPLOAD_STEPS } from '@suvoda-uat/ui-suvoda';
import type { Trial } from '../lib/api-client.js';
import { currentUserName, signOut } from '../lib/auth.js';
import { toProjectRow } from '../lib/dashboard.js';

export type LifecycleStepId = 'upload' | 'verification' | 'assembly' | 'finish';

export type LifecycleTopBarProps = {
  readonly currentStep: LifecycleStepId;
  readonly trial?: Trial | undefined;
  readonly showStage?: boolean;
  readonly onSignOut?: () => void;
  /** Optional action(s) pinned into the topbar's left cluster (e.g. Download). */
  readonly actions?: ReactNode;
};

/**
 * In-trial topbar projection. The dashboard card and the route header both go
 * through `toProjectRow`, so stage/progress/version cannot drift locally.
 * Sign-out (FR-022) is wired by default so every in-trial surface can end the
 * session.
 */
export function LifecycleTopBar({
  currentStep,
  trial,
  showStage = true,
  onSignOut = signOut,
  actions,
}: LifecycleTopBarProps) {
  const row = showStage && trial !== undefined ? toProjectRow(trial) : undefined;
  const stageProps =
    row === undefined
      ? {}
      : {
          stage: row.status,
          ...(row.reviewProgress === undefined ? {} : { reviewProgress: row.reviewProgress }),
          ...(row.latestFinalisedVersion === undefined
            ? {}
            : { latestFinalisedVersion: row.latestFinalisedVersion }),
        };

  return (
    <TopBar
      label="EXPAND"
      userName={currentUserName()}
      center={<ProgressSteps steps={UPLOAD_STEPS} currentId={currentStep} />}
      onSignOut={onSignOut}
      {...(actions ? { actions } : {})}
      {...stageProps}
    />
  );
}
